<div class="titulo-sub-seccion">
    <p>{{ 'PERFILCREZCAMOS.LBL_TOTALGARANTIAS' | translate}}</p>
</div>
<div class="accordion-gris" *ngIf="!banNoInformacion">
    <ng-container *ngIf="unifiedGarantias && unifiedGarantias.length > 0">
        <!-- Total Prendarias -->
        <div class="accordion-gris-header">
            <span>{{ 'PERFILCREZCAMOS.LBL_TOTALPRENDARIAS' | translate }}</span>
            <span>{{ (data?.garantiasHogar?.valorTotal || 0) + (data?.garantiasNegocio?.valorTotal || 0) | formatCurrency }}</span>
        </div>
        <p-accordion>
            <!-- Iterar sobre los datos unificados -->
            <p-accordionTab [ngClass]="{'accordion-gris-header-collapsed': !tab.selected, 'accordion-gris-header-expanded': tab.selected}" #tab *ngFor="let garantia of unifiedGarantias">
                <ng-template pTemplate="header">
                    <div class="accordion-gris-header-item">
                        <div>{{ garantia.label | translate }}</div>
                        <div>{{ garantia.valorTotal | formatCurrency }}</div>
                    </div>
                </ng-template>
                <ng-template pTemplate="content">
                    <ng-container *ngFor="let respaldo of garantia.respaldosCategoriasDTOS">
                        <ng-container *ngIf="respaldo.detalleRespaldos">
                            <ul class="accordion-gris-list">
                                <li *ngFor="let detalle of respaldo.detalleRespaldos">
                                    <div class="accordion-gris-item-respaldos">
                                        <div>{{ detalle.nombre ? detalle.nombre : '-' }}</div>
                                        <div>{{ detalle.valor | formatCurrency }}</div>
                                    </div>
                                </li>
                            </ul>
                        </ng-container>
                    </ng-container>
                </ng-template>
            </p-accordionTab>
        </p-accordion>  
    </ng-container>
    <ng-container *ngIf="data.respaldos && data.respaldos.respaldosCategoriasDTOS.length > 0">
        <!-- Respaldo Total -->
        <div class="accordion-gris-header">
          <span>{{ 'PERFILCREZCAMOS.LBL_TOTALRESPALDOS' | translate }}</span>
          <span>{{ data.respaldos.valorTotal | formatCurrency }}</span>
        </div>
        <p-accordion>
          <p-accordionTab [ngClass]="{'accordion-gris-header-collapsed': !tab.selected, 'accordion-gris-header-expanded': tab.selected}" #tab *ngFor="let respaldo of data.respaldos.respaldosCategoriasDTOS">
                <ng-template pTemplate="header">
                    <div class="accordion-gris-header-item">
                        <div>{{ respaldo.categoria ? respaldo.categoria : '-' }}</div>
                        <div>{{ respaldo.totalValor | formatCurrency }}</div>
                    </div>
                </ng-template>
                <ng-template pTemplate="content">
        
                <!-- Detalles de los respaldos -->
                <ng-container *ngIf="respaldo.detalleRespaldos">
                  <ul class="accordion-gris-list">
                    <li *ngFor="let detalle of respaldo.detalleRespaldos">
                        <div class="accordion-gris-item-respaldos">
                            <div>{{ detalle.nombre ? detalle.nombre : '-' }}</div>
                            <div>{{ detalle.valor | formatCurrency }}</div>
                        </div>
                    </li>
                  </ul>
                </ng-container>
          
                <!-- Subcategorías -->
                <ng-container *ngIf="respaldo.subCategoriasDTOs">
                    <ng-container *ngFor="let subcategoria of respaldo.subCategoriasDTOs">
                      <ul class="accordion-gris-list">
                        <li *ngFor="let detalle of subcategoria.detalleRespaldos">
                            <div class="accordion-gris-item-respaldos">
                                <div>{{ detalle.nombre ? detalle.nombre : '-' }}</div>
                                <div>{{ detalle.valor | formatCurrency }}</div>
                            </div>
                        </li>
                      </ul>
                    </ng-container>
                </ng-container>
        
                </ng-template>
          </p-accordionTab>
        </p-accordion>
    </ng-container>
</div>
<ng-container *ngIf="banNoInformacion">
    <div class="no-hay-informacion">
        <label>{{ this.informacionPerfil.listadoGarantiasDTO.mensaje }}</label>
    </div>
</ng-container>
